// Services Imports
import { getAllPricebooksService } from "./opportunitiesService";
import { generateDocumentID } from "../QuotesActions/QuotesService";

// eslint-disable-next-line import/prefer-default-export
export const getCreateQuoteInitData = category => async dispatch => {
  try {
    const docID = await generateDocumentID(category);
    const priceBooks = await getAllPricebooksService();

    return Promise.all([docID, priceBooks])
      .then(response => {
        dispatch({
          type: "LOAD_PRICELISTS",
          payload: response[1],
        });
        return response[0];
      })
      .catch(error => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
